"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.signedUrlMapper = signedUrlMapper;
exports.departmentMapper = departmentMapper;
const models_1 = require("../models");
function signedUrlMapper(signedUrlResponse) {
    return signedUrlResponse;
}
function departmentMapper(departmentResponse) {
    return {
        createdAt: departmentResponse.createdAt,
        description: departmentResponse.description,
        name: departmentResponse.name,
        organization: departmentResponse.organization,
        organizationId: departmentResponse.organizationId,
        shortHand: models_1.CLINICIAN_ROLES[departmentResponse.shortHand],
        status: departmentResponse.status,
        id: departmentResponse._id,
    };
}
